module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h2 class="center">\n    Registration form\n</h2>\n<div class="container signup-form">\n    <div id="person-form" class="edit-form"></div>\n    <div id="edit-buttons" class="edit-buttons">\n        <div class="left-buttons">\n            <button type="button" class="btn btn-primary" id="perform-signup" disabled>Sign up</button>\n        </div>\n    </div>\n</div>\n\n<div id="inform"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/persons/signup.html
// module id = 391
// module chunks = 0